export const MOBILE_AIRPORT_SHEET_KEYBOARD_OPEN_CLASS = 'is-keyboard-open';

export const MOBILE_AIRPORT_SHEET_VV_HEIGHT_VAR = '--mobile-vv-height';

export const MOBILE_AIRPORT_SHEET_KEYBOARD_INSET_VAR = '--mobile-keyboard-inset';

/** Treat this inset as an open keyboard (Chrome iOS suggestion bar is ~44px). */
export const MOBILE_AIRPORT_SHEET_KEYBOARD_OPEN_INSET_PX = 80;
